exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box}body{height:2000px;background-color:#fcfcff;position:relative;margin:0;padding:0}#app{font-family:Avenir,Helvetica,Arial,sans-serif;text-align:left;color:#2c3e50;margin-top:60px;max-width:980px;min-width:320px;margin:0 auto}h1{margin-top:100px;font-weight:600;font-size:40px;padding-bottom:20px;border-bottom:1px solid #2c3e50}.form-control{margin-bottom:20px}label{display:inline-block;margin-bottom:8px}input{border:1px solid #ccc;outline:none;padding:5px 15px 5px 10px;border-radius:3px;font-size:15px;width:200px;height:35px}.footer{position:absolute;bottom:0;left:0;right:0;height:300px;display:flex;align-items:center;justify-content:center;background-color:#999}.footer h2{font-size:30px;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2488d613","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 8
// module chunks = 0